import React, { useState, useEffect } from 'react';
import { Tabs, Select, Grid } from 'antd';

const { useBreakpoint } = Grid;

/**
 * Geniş ekranda SEKME, telefonda AÇILIR LİSTE.
 *
 * NEDEN: 375px'te sekme çubuğuna ayrılan yer 268px, beş sekmenin toplam
 * genişliği 628px. Sadece birincisi ve ikincisinin yarısı görünüyordu.
 * AntD'nin taşma için koyduğu "…" düğmesi teknik olarak çalışıyor ama küçük
 * bir üç nokta kimseye "burada 3 sekme daha var" demiyor — kullanıcı
 * bildirdi: "kaç adet olduğu ve sağa kaydırılıp kaydırılmayacağı belli
 * olmuyor" (2026-08-26).
 *
 * Açılır liste bunu tek bakışta çözüyor: hangi sekmedeyiz yazıyor,
 * dokununca hepsi birden listeleniyor, kaydırma derdi yok.
 *
 * MASAÜSTÜ DEĞİŞMİYOR — md (768px) ve üstünde birebir aynı `<Tabs>`.
 *
 * Kullanım: `<Tabs ... />` yerine `<ResponsiveTabs ... />`. `items` API'si
 * aynen geçerli; kontrollü (activeKey + onChange) ve kontrolsüz
 * (defaultActiveKey) kullanımların ikisi de destekleniyor.
 */
const ResponsiveTabs = ({
  items = [],
  activeKey,
  defaultActiveKey,
  onChange,
  ...rest
}) => {
  const ekran = useBreakpoint();

  // Kontrolsüz kullanımda seçili sekmeyi kendimiz tutuyoruz; kontrollüde
  // (activeKey verilmişse) dışarıdaki değer geçerli.
  const [icSecili, setIcSecili] = useState(defaultActiveKey ?? items[0]?.key);

  // Dışarıdan gelen liste değişirse (ör. öğrenci değişti) seçili sekme artık
  // listede olmayabilir; öyleyse ilkine dön, yoksa ekran boş kalır.
  useEffect(() => {
    if (activeKey !== undefined) return;
    if (items.length && !items.some(i => i.key === icSecili)) {
      setIcSecili(items[0].key);
    }
  }, [items, icSecili, activeKey]);

  if (ekran.md) {
    return (
      <Tabs
        items={items}
        activeKey={activeKey}
        defaultActiveKey={defaultActiveKey}
        onChange={onChange}
        {...rest}
      />
    );
  }

  const secili = activeKey ?? icSecili;
  const aktif  = items.find(i => i.key === secili) || items[0];

  const degistir = (k) => {
    if (activeKey === undefined) setIcSecili(k);
    onChange?.(k);
  };

  return (
    <div>
      <Select
        value={aktif?.key}
        onChange={degistir}
        style={{ width: '100%' }}
        className="mb-3"
        // Etiketler ReactNode olabiliyor (sayaç rozetli "Devam Eden (3)"
        // gibi); `label` olarak aynen geçiyor, ayrıca metne çevirmiyoruz.
        options={items.map(i => ({ value: i.key, label: i.label, disabled: i.disabled }))}
      />
      <div>{aktif?.children}</div>
    </div>
  );
};

export default ResponsiveTabs;
